export default "__VITE_ASSET__CZr5fzXP__"